import bookCatalog from './bookCatalog'
import bookReading from './bookReading'
import challenge from './challenge'
import dashboard from './dashboard'
import home from './home'
import initialTour from './initialTour'
import navigation from './navigation'
import profile from './profile'
import library from './library'
import ranking from './ranking'
import store from './store'
import dictionary from './dictionary'
import categories_tl from './categories'

export default {
    loggedOut: 'No hay una sesión activa',
    points: 'Puntos',
    avatars: 'Avatares',
    categories: 'Categorías',
    save: 'Guardar',
    title_dashboard: 'Inicio | Beeverso',
    title_bookReading: 'Experiencia Lectora | Beeverso',
    title_book_catalog: 'Catálogo de libros | Beeverso',
    title_messages: 'Mensajes | Beeverso',
    title_library: 'Biblioteca | Beeverso',
    title_articles: 'Mis artículos | Beeverso',
    title_challenges: 'Desafíos | Beeverso',
    title_ranking: 'Ranking | Beeverso',
    title_profile: 'Perfil | Beeverso',
    title_store: 'Tienda | Beeverso',
    index: 'Inicio',
    challenges: 'Desafíos',
    messages: 'Mensajes',
    books: 'Libros',
    select_avatar: 'Seleccionar Avatar y Categorías',
    logout: 'Cerrar Sesión',
    menu_mission: 'Misiones y Logros',
    your_level: 'Tu Nivel',
    experience_points: 'Puntos de Experiencia',
    beeCoins: 'BeeCoins',
    level: 'Nivel',
    read: 'Leer',
    unknown: 'Desconocido',
    msg_error: '¡Ups!',
    msg_warning: '¡Advertencia!',
    msg_info: '¡Información!',
    msg_success: '¡Muy Bien!',
    msg_rewards: '¡Felicidades!',
    msg_load_error: 'Error al cargar contenido',
    txt_load_error: 'Haz clic en el botón de aceptar para recargar la página y volverlo a intentar',
    general_error_message: 'Ocurrió un error, intente de nuevo más tarde',
    anonymous: 'Anónimo',
    button_yes: 'Sí',
    button_no: 'No',
    button_close: 'Cerrar',
    button_accept: 'Aceptar',
    next: 'Siguiente',
    questions: 'Preguntas',
    nextQuestion: 'Siguiente pregunta',
    nextText: 'Siguiente Texto',
    slogan: '8 años de experiencia en tecnología educacional.',
    company_name: 'Beeverso',
    your_messages: 'Tus Mensajes',
    from: 'De:',
    go_back: 'Volver',
    comments: 'Comentarios',
    no_comment: 'No hay comentarios',
    more_nine_comments: '+9 Comentarios',
    of: 'de',
    true: 'Verdadero',
    false: 'Falso',
    beecoins: 'BeeCoins',
    about: 'Sobre',
    greet: '¡Hola',
    greet_msg: 'espero te encuentres bien en este maravilloso día',
    exit: 'Salir',
    download_app_message: 'Descarga nuestra aplicación para ingresar',
    challenge_not_exists: 'El desafío que intenta buscar no existe.',
    general: {
        error_msg: "Ha ocurrido un error. Por favor intertarlo nuevamente. Si el error persiste, pedir apoyo al equipo de desarrollo"
    },
    bookCatalog,
    bookReading,
    challenge,
    dashboard,
    home,
    initialTour,
    navigation,
    profile,
    library,
    ranking,
    store,
    dictionary,
    categories_tl
}
